
import {LOAD_REPORT_INFO_ERROR, LOAD_REPORT_INFO_REQUEST, LOAD_REPORT_INFO_SUCCESS} from "./report-info-action-types";

const initialState = {
  title: "",
  dateCreated: "",
  dateDownloaded: "",
  loading: false,
  whoMounted: null,
  error: ""
};


export default ( state = initialState, action ) => {
  const { reportInfo, error, reportUrl } = action;

  switch(action.type) {

    case LOAD_REPORT_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        whoMounted: reportUrl,
        error: ""
      };

    case LOAD_REPORT_INFO_SUCCESS:
      return {
        ...state,
        title: reportInfo && reportInfo.title || 'No title',
        dateCreated: reportInfo && reportInfo.date_created || 'No date created',
        dateDownloaded: reportInfo && reportInfo.download_date && reportInfo.download_date.$date || undefined,
        loading: false,
        error: ""
      };

    case LOAD_REPORT_INFO_ERROR:
      return {
        ...state,
        loading: false,
        error
      };


    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/report-info/report-info-reducer.js